/* eslint-disable no-undef */

const $ = require('jquery');
const util = require('../utils/util');

/**
 *
 */
exports.init = function () {
    $('.countryselection .country-site').on('click', function () {
        let targetUrl = this.href;
        const countrySwitcherUrlParams = {};

        if (typeof redirectData === 'object' && redirectData !== null) {
            if (redirectData.targetNode) {
                countrySwitcherUrlParams.TargetNode = redirectData.targetNode;
            }

            if (redirectData.targetParameters) {
                countrySwitcherUrlParams.TargetParameters = redirectData.targetParameters;
            }

            if (redirectData.geoRedirect) {
                countrySwitcherUrlParams.GeoRedirect = redirectData.geoRedirect;
            }

            targetUrl = util.appendParamsToUrl(targetUrl, countrySwitcherUrlParams);
        }

        // Preserve original URL parameters
        const queryString = window.location.search;
        const parameters = new URLSearchParams(queryString);
        const preservedUrlParameters = {};

        // traverse parameters and add them to the target URL
        parameters.forEach(function (value, key) {
            // filter out existing country switcher URL params
            if (!countrySwitcherUrlParams[key]) {
                preservedUrlParameters[key] = value;
            }
        });

        targetUrl = util.appendParamsToUrl(targetUrl, preservedUrlParameters);
        this.href = targetUrl;
    });
};
